import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_vd_sleep extends Component {
    constructor(props) {
        super(props);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        var ctx = document.getElementById('Chart_vd_sleep').getContext('2d');
        const data = this.props.data;
        const date = this.props.date;
        var x_wake = [];
        var x_light = [];
        var x_rem = [];
        var x_deep = [];
        var y_data = [];
        for (var i = 0; i < data['wake'].length; i++) {
            x_wake.push(data['wake'][i]['sum']);
            x_light.push(data['light'][i]['sum']);
            x_rem.push(data['rem'][i]['sum']);
            x_deep.push(data['deep'][i]['sum']);
            var tmp = format(new Date(data['wake'][i]['time']), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        var isstepped = false;
        if (window.Chart_vd_sleep instanceof Chart) window.Chart_vd_sleep.destroy();
        window.Chart_vd_sleep = new Chart(ctx, {
            type: "bar",
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Deep (seconds)',
                        data: x_deep,
                        backgroundColor: '#303956',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Light (seconds)',
                        data: x_light,
                        backgroundColor: '#37718E',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'REM (seconds)',
                        data: x_rem,
                        backgroundColor: '#A0ADA8',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    },
                    {
                        label: 'Wake (seconds)',
                        data: x_wake,
                        backgroundColor: '#D60000',
                        datalabels: {
                            // color: '#000000',
                            // anchor: 'center',
                            // align: 'center',
                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                legend: {
                    align: 'center',
                    labels: {
                        padding: 5
                    },
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        stacked: true,
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                    yAxes: [{
                        stacked: true
                    }]
                },
                title: {
                    display: true,
                    text: "Daily Sleep Times",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_vd_sleep"></canvas>
            </div>
        );
    }
}